import ProgressBar from "components/progress_bar";

import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import clsx from "clsx";

export default function Steps(props) {
  const { step, completedRate, totalPages } = props;
  const { onPaginate } = props;
  const { loading } = props;

  const renderPrevStep = step > 1;
  const renderNextStep = step < totalPages;

  return (
    <div className="step flex-col items-center">
      <div className="flex items-center justify-between">
        <Chevron
          direction="left"
          onClick={() => onPaginate("prev")}
          invisible={!renderPrevStep || loading}
          loading={loading}
        />

        <div className="flex-col items-center">
          <span
            className={clsx(
              "fade-loading block mb-2 text-center text-xl font-semibold",
              {
                loading
              }
            )}
          >
            Etapa {step}
          </span>
          {completedRate !== undefined && (
            <span
              className={clsx(
                "fade-loading block text-center text-emphasis-medium",
                {
                  loading
                }
              )}
            >
              {Math.round(completedRate * 100)}% completa
            </span>
          )}
        </div>

        <Chevron
          direction="right"
          onClick={() => onPaginate("next")}
          invisible={!renderNextStep || loading}
          loading={loading}
        />
      </div>

      {completedRate !== undefined && (
        <div className="mt-4">
          <ProgressBar
            completion={completedRate}
            loading={loading}
            color="bg-gray-400"
          />
        </div>
      )}
    </div>
  );
}

function Chevron(props) {
  const { direction, onClick, invisible } = props;

  const Icon = direction === "left" ? FiChevronLeft : FiChevronRight;

  return (
    <div
      onClick={onClick}
      className={clsx(
        "chevron text-emphasis-medium cursor-pointer",
        direction,
        {
          invisible
        }
      )}
    >
      <Icon size={28} />
    </div>
  );
}
